// TODO(ui-foundation): promote as a generic <RequireAuth> route guard. Today
// it's coupled to useJwtAuth + react-router; the ui-foundation version should
// accept an `isAuthenticated`/`status` source and a redirect path as props.
import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { AUTH_STATUS } from "@app/lib/auth-constants";
import { NotAuthorizedState } from "@app/components/auth-guard/not-authorized-state";
import type { RoleLabel } from "@app/lib/role-constants";
import { getRoleLabelFromJwtRoles } from "@app/lib/role-utils";
import { useJwtAuth } from "@app/providers/jwt-auth-provider";

type AuthGuardProps = {
  children?: ReactNode;
  allowedRoles?: RoleLabel[];
};

export function AuthGuard({ children, allowedRoles }: AuthGuardProps) {
  const location = useLocation();
  const { status, isAuthenticated, user } = useJwtAuth();

  if (status === AUTH_STATUS.LOADING) {
    return (
      <section className="events-page">
        <p>Authorizing session…</p>
      </section>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: {
            pathname: location.pathname,
            search: location.search,
          },
        }}
      />
    );
  }

  if (allowedRoles?.length) {
    const roleLabel = getRoleLabelFromJwtRoles(user?.roles);

    if (!allowedRoles.includes(roleLabel)) {
      return <NotAuthorizedState />;
    }
  }

  if (children) {
    return <>{children}</>;
  }

  return <Outlet />;
}
